import { Injectable } from '@angular/core';
import {
  PublicOfferFormDetails,
  SendPublicOfferFormPayload,
  SendPublicOfferFormResponse,
} from '@features/public-offer-form/utils/models/public-offer-form.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class PublicOfferFormService extends HttpHandler {
  validateOfferForm(userId: number): Observable<HttpResponse<PublicOfferFormDetails>> {
    const url: string = environment.apiUrls.offers.validate;
    const params = { user_id: userId };
    return this.post<HttpResponse<PublicOfferFormDetails>>(url, params);
  }

  sendOfferForm(payload: SendPublicOfferFormPayload): Observable<HttpResponse<SendPublicOfferFormResponse>> {
    const url: string = environment.apiUrls.offers.sendPublic;
    const formData: FormData = new FormData();
    Object.entries(payload)
      .filter(([, value]) => (value instanceof Array ? value.length : value))
      .forEach(([key, value]) => {
        if (value instanceof Array) {
          value.forEach((item, index) => {
            formData.append(`${key}[${index}]`, item);
          });
        } else {
          formData.append(key, typeof value === 'number' ? value.toString() : value);
        }
      });
    return this.post<HttpResponse<SendPublicOfferFormResponse>>(url, formData, {
      recaptchaAction: 'submit_public_offer_form',
    });
  }
}
